import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    form: {
      creditorIdentifier: {
        errorInvalidIdentifier: 'The identifier is not valid.',
        label: 'SEPA Creditor Identifier (SCI)',
        placeholder: 'Ex: FR46ZZZ005002',
      },
      creditorName: {
        label: 'Creditor Name',
        placeholder: 'Ex: Direction générale des Finances publiques',
      },
      label: {
        hint: 'Optional',
        label: 'Custom label',
        placeholder: 'Ex: DGFIP - TVA',
      },
      uniqueMandateReference: {
        helpText: '35 alpha-numeric characters maximum.',
        label: 'Unique Mandate Reference (UMR)',
        placeholder: 'Ex: NN834752792GDFIP2018',
      },
    },
    formErrorEmptyField: 'This field is required.',
    subTitle:
      'This information must be completed carefully. An error will result in the refusal of the direct debit.',
    title: 'Authorize a new B2B Mandate',
  },
  fr: {
    form: {
      creditorIdentifier: {
        errorInvalidIdentifier: 'Cet identifiant n’est pas valide.',
        label: 'Identifiant Créancier SEPA (ICS)',
        placeholder: 'Ex\xA0: FR46ZZZ005002',
      },
      creditorName: {
        label: 'Nom du créancier',
        placeholder: 'Ex\xA0: Direction Générale des Finances Publiques',
      },
      label: {
        hint: 'Facultatif',
        label: 'Libellé personnalisé',
        placeholder: 'Ex\xA0: DGFIP - TVA',
      },
      uniqueMandateReference: {
        helpText: '35 caractères alphanumériques maximum.',
        label: 'Référence Unique de Mandat (RUM)',
        placeholder: 'Ex\xA0: NN834752792GDFIP2018',
      },
    },
    formErrorEmptyField: 'Ce champ est requis.',
    subTitle:
      'Ces informations doivent être complétées avec attention. Une erreur entraînera le refus du prélèvement automatique.',
    title: 'Autoriser un nouveau mandat SEPA interentreprises',
  },
});

export default locales;
